"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function NewArrivalsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="82580" className="w-full overflow-hidden px-4 md:px-8">
        <div className="flex gap-6">
          {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="w-[280px] shrink-0 md:w-[320px]">
              <div className="aspect-[4/5] w-full animate-pulse rounded-sm bg-muted/40" />
              <div className="mt-4 space-y-3">
                <div className="h-5 w-2/3 animate-pulse rounded bg-muted/40" />
                <div className="h-4 w-1/3 animate-pulse rounded bg-muted/40" />
              </div>
            </div>)}
        </div>
      </div>;
  }
  if (error) {
    return <div className="px-4 py-12 text-center md:px-8">
        <p className="font-sans text-muted-foreground">Failed to retrieve our cellar's award-winning selections.</p>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="px-4 py-12 text-center md:px-8">
        <p className="font-sans text-muted-foreground">Our curated selections are currently being updated. Please visit us again soon.</p>
      </div>;
  }
  return <ScrollArea className="w-full whitespace-nowrap">
      <div className="flex w-max space-x-6 px-4 pb-12 md:px-8">
        {products.map((product, i) => <div key={product.id} data-index={i} className="w-[280px] shrink-0 snap-center md:w-[320px]">
            <Card className="group relative h-full overflow-hidden rounded-sm border-border/40 bg-card/50 shadow-sm transition-all hover:border-secondary/50 hover:shadow-lg">
              {}
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted/5">
                <div className="absolute left-4 top-4 z-10">
                  <Badge variant="outline" className="border-secondary/40 bg-background/90 font-mono text-[10px] tracking-widest text-secondary backdrop-blur-sm">
                    95 PTS
                  </Badge>
                </div>
                
                <Link to={product.link} className="block h-full w-full">
                  {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted/10 text-xs font-sans text-muted-foreground">
                      IMAGE PENDING
                    </div>}
                </Link>

                {}
                <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-background/98 via-background/90 to-transparent p-4 pt-16 transition-transform duration-500 ease-out group-hover:translate-y-0">
                  <AddToCartButton productId={product.id} className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-sans text-xs font-bold tracking-widest uppercase rounded-sm transition-colors" text="Quick Add" showQuantity={false} />
                </div>
              </div>

              {}
              <CardContent className="p-6">
                <Link to={product.link} className="block">
                  <h3 className="mb-2 truncate font-serif text-xl font-bold text-foreground transition-colors group-hover:text-primary">
                    {product.title}
                  </h3>
                  <p className="font-mono text-sm font-medium tracking-tight text-secondary">
                    ${product.price?.toFixed(2)}
                  </p>
                </Link>
              </CardContent>
            </Card>
          </div>)}
      </div>
      <ScrollBar orientation="horizontal" className="bg-secondary/10" />
    </ScrollArea>;
}
export default function AwardWinningSelections() {
  const wp_query_params = {
    per_page: 8,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="award-winning-selections" className="relative overflow-hidden bg-background py-24 text-foreground">
      {}
      <div className="pointer-events-none absolute left-1/2 top-0 h-[500px] w-full max-w-6xl -translate-x-1/2 rounded-full bg-secondary/5 blur-[120px]" />

      <div className="container relative z-10 mx-auto mb-16 px-4 md:px-8">
        <div className="flex flex-col items-start gap-4">
          <span className="font-mono text-xs font-bold tracking-[0.3em] text-secondary uppercase">
            Curated From The Cellar
          </span>
          <h2 className="max-w-2xl font-serif text-4xl font-bold italic tracking-tight text-primary md:text-5xl lg:text-6xl">
            Award-Winning Selections
          </h2>
        </div>
      </div>

      <div className="relative z-10 w-full">
        <EcommerceProductsProvider wp_query={{
        per_page: 8,
        orderby: "date",
        order: "desc"
      }}>
          <NewArrivalsConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}